import { useEffect } from 'react';
import useExceptionLogger from '~/hooks/useExceptionLogger';
import { assertIsDefined } from '~/types/typeGuards';

const HubSpot = () => {
  const { captureException } = useExceptionLogger();
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = '//js-eu1.hs-scripts.com/24972410.js';
    const hubspotContainer = document.getElementById('hubspot-container');

    script.onerror = (err) => {
      captureException(err, {
        extra: {
          help_text: 'error on houbspot script loading',
        },
      });
    };

    assertIsDefined(hubspotContainer, 'hubspotContainer cannot be null or undefined');
    try {
      hubspotContainer.appendChild(script);
    } catch (err) {
      captureException(err, {
        extra: {
          help_text: 'error on houbspot init',
        },
      });
    }
  }, [captureException]);

  return <div id="hubspot-container"></div>;
};

export default HubSpot;
